import React, { useRef, useCallback } from "react";
import { Form, Row, Col, Select } from "antd";

/**
 * 权限列表筛选。权限码和描述走快捷搜索，这里按业务模块和操作收窄。
 */
const PermissionListFilter = ({ onSearch, moduleOptions = [], actionOptions = [], autoApply = false }) => {
    const [form] = Form.useForm();
    const debounceRef = useRef(null);

    const handleSearch = useCallback(() => {
        form.validateFields().then((values) => {
            onSearch(values);
        });
    }, [form, onSearch]);

    const handleValuesChange = useCallback(() => {
        if (!autoApply) return;
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            handleSearch();
        }, 300);
    }, [autoApply, handleSearch]);

    return (
        <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
            <Row gutter={24}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="module" label="业务模块" extra="权限码冒号前的那一段，例如 user、settlement">
                        <Select allowClear showSearch placeholder="全部模块" optionFilterProp="label" options={moduleOptions} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="action" label="操作" extra="权限码最后一段，例如 read、update">
                        <Select allowClear showSearch placeholder="全部操作" optionFilterProp="label" options={actionOptions} />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default PermissionListFilter;
